import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        const result = await login({ username, password });

        if (result.success) {
            // Each role lands on its own Today page
            const role = result.data.user?.role;
            navigate(role === 'admin' ? '/admin/dashboard' : role === 'writer' ? '/today' : '/');
        } else {
            if (result.requiresApproval) {
                setError(
                    `Shift overlap detected. ${result.existingShift.operator} has an active shift. ` +
                    `Admin approval required.`
                );
            } else {
                setError(result.error);
            }
        }

        setLoading(false);
    };

    const today = new Date().toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short', year: 'numeric' });

    return (
        <main className="min-h-[100dvh] flex flex-col md:flex-row bg-background font-sans">
            {/* Company panel: navy, same as the top bar inside the app */}
            <section className="bg-navy text-white md:w-[44%] md:max-w-[560px] px-6 py-6 md:p-14 flex md:flex-col md:justify-between items-center md:items-start gap-4">
                <div className="flex items-center gap-2.5 text-[17px] font-extrabold tracking-[-0.01em]">
                    <span className="w-9 h-9 rounded-[10px] bg-accent flex items-center justify-center text-[15px]">F</span>
                    FactoryDash
                </div>
                <div className="hidden md:block">
                    <h1 className="text-[34px] leading-[1.15] font-extrabold text-white">Aarya Plastopet</h1>
                    <p className="mt-3 mb-0 text-[15px] font-semibold text-[#9FB3CC] max-w-[340px]">Production, stock and people for the factory, in one place.</p>
                </div>
                <p className="hidden md:block m-0 text-xs font-semibold text-[#6F86A6]">{today}</p>
            </section>

            <section className="flex-1 flex items-start md:items-center justify-center px-4 py-8 md:p-10">
                <div className="w-full max-w-[400px] bg-card rounded-2xl shadow-soft p-6 md:p-8 fd-rise">
                    <h2 className="text-[22px] font-extrabold text-text-primary">Sign in</h2>
                    <p className="mt-1 mb-5 text-[13px] font-semibold text-text-muted">Use the username your admin gave you.</p>

                    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                        {error && (
                            <div className="rounded-xl bg-danger/10 text-danger text-[13px] font-semibold px-3.5 py-2.5" role="alert">
                                {error}
                            </div>
                        )}

                        <div className="flex flex-col gap-1.5">
                            <label className="hb-label" htmlFor="login-username">Username</label>
                            <input
                                id="login-username"
                                type="text"
                                className="hb-input"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                placeholder="e.g. operator1"
                                autoComplete="username"
                                autoCapitalize="none"
                                spellCheck={false}
                                required
                                autoFocus
                            />
                        </div>

                        <div className="flex flex-col gap-1.5">
                            <label className="hb-label" htmlFor="login-password">Password</label>
                            <input
                                id="login-password"
                                type="password"
                                className="hb-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="••••••••"
                                autoComplete="current-password"
                                required
                            />
                        </div>

                        <button type="submit" className="hb-btn hb-btn-lg w-full mt-1" disabled={loading}>
                            {loading ? (<><span className="spinner"></span>Signing in…</>) : 'Sign in'}
                        </button>
                        <p className="m-0 text-center text-xs font-semibold text-text-muted">Operators: signing in starts your shift.</p>
                    </form>
                </div>
            </section>
        </main>
    );
};

export default Login;
